import { IPhotosOrder } from '@/models/products.model';
import { PhotoItem } from './configs';

// an array of only new files in a separate array
export const getNewAddedFiles = (photoItems: PhotoItem[]): File[] =>
  photoItems.map((photoItem) => photoItem?.originFileObj).filter((el): el is File => !!el);

// uuids in the appropriate order to array of newly added files
export const getNewAddedFilesIds = (photoItems: PhotoItem[]): string[] =>
  photoItems.filter((el) => !!el?.originFileObj).map((photoItem) => photoItem.uid);

// array of orders for all product photos
export const getProductPhotosOrdersList = (photoItems: PhotoItem[]): IPhotosOrder[] =>
  photoItems.map((photoItem) => ({ id: photoItem.uid, order: photoItem.order }));
